import { render, staticRenderFns } from "./traces-list.vue?vue&type=template&id=5c053fbe&"
import script from "./traces-list.vue?vue&type=script&lang=js&"
export * from "./traces-list.vue?vue&type=script&lang=js&"
import style0 from "./traces-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports